import placeCursorAfterGallery from "@ext/markdown/elements/gallery/edit/logic/placeCursorAfterGallery";
import { clipboardHasRichText } from "@ext/markdown/elements/image/edit/logic/imageHandlePaste";
import { Plugin, PluginKey } from "prosemirror-state";

const pastesImageFiles = (event: ClipboardEvent) =>
	event.clipboardData.files.length > 0 && !clipboardHasRichText(event);

const galleryPastePlugin = () =>
	new Plugin({
		key: new PluginKey("galleryPaste"),
		props: {
			handleDOMEvents: {
				// Runs before every paste handler: each of them then lands the text after the gallery, not over its item.
				paste: (view, event) => {
					if (!view.editable || !event.clipboardData || pastesImageFiles(event)) return false;
					const tr = placeCursorAfterGallery(view.state);
					if (tr) view.dispatch(tr);
					return false;
				},
			},
		},
	});

export default galleryPastePlugin;
